import React, { useState, useEffect,useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
//import { useAction,useQuery } from 'convex/react';
//import { api } from './convex/_generated/api';
//import { useAuth } from './contexts/AuthContext';
import { toast } from 'sonner';
import axios from "axios";



const PACKS = [
  {
    id: "premium",
    title: "Lead Gen / Content Creation Pack (Subscription)",
    price: "$1500/mo",
    includes: [
      "Cold outreach message templates (email + LinkedIn)",
      "High-converting hook formulas for posts",
      "Content calendar framework (30-day plan)",
      "DM scripts that turn prospects into booked calls",
      "Follow-up sequences that increase response rates",
      "Lead magnet ideas + funnel structures",
      "Authority-building content templates"
    ],
    color: "#C8A96E",
    popular: true
  }
];

export default function PricingPage() {
  const [checkoutLoading, setCheckoutLoading] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  //const sessionId = location.state?.sessionId;
  const sessionId = location.state?.sessionId || localStorage.getItem('session_id');
  console.log(sessionId);
  
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  
  useEffect(() => {
    const fetchUser = async () => {
      try {
        //const res = await axios.get('https://backend-contentplatform-10.onrender.com/user', { withCredentials: true });
        const res = await axios.get( `${process.env.REACT_APP_BACKEND_URL}/user`,{
      params: { sessionId },
      });
        setUser(res.data || null);
      } catch {
        setUser(null);
      }
    };
    fetchUser();
  }, []);



useEffect(() => {
  if (
    user?.role === 'premium'
  ) {
    toast.success("You already have access!");
    localStorage.setItem("session_id", sessionId);
    navigate("/dashboard", { state: { sessionId } });
  }
}, [user, sessionId, navigate]);

  const handleGetPack = async (packId) => {
    console.log(packId);
    if (!sessionId) {
      toast.error("Please sign in first");
      navigate("/");
      return;
    }
    
    setCheckoutLoading(packId);
    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/createcheckoutsession`,{
    userId: user.userId,
    email: user.email,
    packId: packId
  }
);
      window.location.href = res.data.url;
    } catch (err) {
      toast.error("Failed to start checkout");
    } finally {
      setCheckoutLoading(null);
    }
  };

  const handleManage = async (packId) => {
  setCheckoutLoading("portal");
  try {
    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/create-portal-session`,{
    userId: user.userId,
    packId: packId
  })
   window.location.href = res.data.url;
  } catch (err) {
    setError("Failed to open billing portal");
  } finally {
    setCheckoutLoading(null);
  }
};

//const isPro = user?.role === "pro";

function userHasPack(user, packId) {
  return packId === "premium" && user?.role === "premium";
}

  return (
    <section style={{ width:"1400px", margin: "0 auto", padding: "48px 24px", animation: "fadeUp 0.4s ease both" }}>
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <h2 style={S.sectionTitle}>High-Stakes Packs</h2>
        <p style={{ color: "#666", fontSize: 16 }}>Full playbooks for when it really matters</p>
        <p style={{ color: "#555", fontSize: 13, marginTop: 8 }}>All packs included in one Pro subscription — $1500/mo</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 20, marginBottom: 32 }}>
        {PACKS.map(pack => (
          <div key={pack.id} style={{
            ...S.packCard,
            borderColor: pack.popular ? pack.color : "rgb(42, 42, 53)",
            animation: pack.popular ? "glow 3s ease infinite" : "none",
          }}>
            {pack.popular && (
              <div style={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", fontSize: 11, fontWeight: 700, color: "#0C0C0E", padding: "4px 14px", borderRadius: 20, background: pack.color, whiteSpace: "nowrap" }}>
                Most Popular
              </div>
            )}
            <div style={{ fontSize: 22, color: pack.color, marginBottom: 12 }}>✦</div>
            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 19, fontWeight: 700, color: "#F0F0F5", marginBottom: 6 }}>
              {pack.title}
            </h3>
            <div style={{ fontSize: 28, fontWeight: 700, fontFamily: "'Playfair Display', serif", color: pack.color, marginBottom: 20 }}>
              {pack.price}
            </div>
            <div style={{ marginBottom: 24 }}>
              {pack.includes.map((item, i) => (
                <div key={i} style={{ fontSize: 13, color: "#666", padding: "6px 0", borderBottom: "1px solid #1a1a22" }}>
                  ✓ {item}
                </div>
              ))}
            </div>
            {userHasPack(user, pack.id) ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div style={{ fontSize: 12, color: "#4a9a6a", textAlign: "center", padding: "8px", background: "#0F1A12", borderRadius: 8, border: "1px solid #2a4a30" }}>
                    ✓ Active
                    </div>
                    <button
                    disabled={true}
                    onClick={() => handleManage(pack.id)}
                    style={{ width: "100%", border: "1px solid #E07A7A", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, color: "#E07A7A", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", background: "transparent" }}>
                    Cancel Subscription
                    </button>
            </div>
                ) : (
                <button
                    disabled={true}
                    onClick={() => handleGetPack(pack.id)}
                    style={{ width: "100%", border: "none", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, color: "#0C0C0E", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", background: pack.color }}>
                    Get This Pack
                </button>
                )}
          </div>
        ))}
      </div>

    </section>
  );
}

const S = {
  sectionTitle: { fontFamily: "'Playfair Display', serif", fontSize: 34, fontWeight: 700, color: "#F0F0F5", marginBottom: 10 },
  packCard: { background: "#13131A", border: "1px solid #1E1E28", borderRadius: 16, padding: "28px 24px", position: "relative" },
};
